import React, { useState, useEffect } from "react";
import styled from "styled-components";
import tw from "twin.macro";

const LoaderContainer = styled.div`
  ${tw`fixed inset-0 flex items-center justify-center z-50 transition-opacity duration-500`}
  background-color: rgba(0, 0, 0, 0.9);
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  pointer-events: ${({ isVisible }) => (isVisible ? "auto" : "none")};
`;

const BarContainer = styled.div`
  ${tw`w-64 h-2 rounded-full overflow-hidden`}
  background-color: #333;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.1);
`;

const Bar = styled.div`
  ${tw`h-full`}
  background-color: #00ffe0;
  animation: fillBar 1.5s ease-in-out forwards;

  @keyframes fillBar {
    0% {
      width: 0%;
    }
    100% {
      width: 100%;
    }
  }
`;

const Loader = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsVisible(false);
    }, 1800); // Esperamos justo lo que dura la animación

    return () => clearTimeout(timeout);
  }, []);

  return (
    <LoaderContainer isVisible={isVisible}>
      <BarContainer>
        <Bar />
      </BarContainer>
    </LoaderContainer>
  );
};

export default Loader;
